import { createContext } from 'react';

export interface SuccessMessageContextType {
  showSuccess: (message: string) => void;
  hideSuccess: () => void;
}

export const SuccessMessageContext = createContext<SuccessMessageContextType | undefined>(
  undefined,
);
